module.exports = __webpack_public_path__ + "img/43.4eb537e8.jpeg";